import { Box } from '@cdl/heartbeat-react';
import React from 'react';

export const FrozenMarker: React.FC = () => {
  return (
    <Box
      borderRadius='50%'
      bgColor='primary.500'
      width='0.5rem'
      height='0.5rem'
    />
  );
};
